import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { feedbackReducer } from 'easycommons/modules/Feedback'
import { MenuBarReducer } from 'easycommons/modules/MenuBar'
import notification from './notification'
import investorProfile from './investorProfile'
import businessInfo from './businessInfo'
import bankAccount from './bankAccount'
import addressInfo from './addressInfo'
import customerAccount from './customerAccount'
import featureToggle from './featureToggle'
import easyToken from './easyToken'
import personalInfo from './personalInfo'
import financialTransferAccounts from './financialTransferAccounts'
import transferSecurity from './transferSecurity'
import transactionHistory from './transactionHistory'
import accountStatement from './accountStatement'
import content from './content'
import bankInfo from './bankInfo'
import incomeReport from './incomeReport'
import irrf from './irrf'
import invoices from './invoices'
import financialSituation from './financialSituation'
import financialPosition from './financialPosition'
import account from './account'
import withdrawal from './withdrawal'
import pendency from './pendency'
import maritalStatusOptions from './maritalStatusOptions'
import withdrawalMessage from './withdrawalMessage'
import yearsIncomeReport from './yearsIncomeReport'
import notifications from './notifications'
import brokers from './brokers'
import custodyInvestments from './custodyInvestments'
import custodyAndPosition from './custodyAndPosition'
import accountsFinancialPosition from './accountsFinancialPosition'

export default combineReducers({
  form: formReducer,
  bankInfo,
  notification,
  investorProfile,
  businessInfo,
  bankAccount,
  addressInfo,
  customerAccount,
  featureToggle,
  easyToken,
  personalInfo,
  financialTransferAccounts,
  transferSecurity,
  transactionHistory,
  accountStatement,
  content,
  MenuBarReducer,
  incomeReport,
  financialSituation,
  irrf,
  invoices,
  financialPosition,
  account,
  withdrawal,
  feedback: feedbackReducer,
  pendency,
  maritalStatusOptions,
  withdrawalMessage,
  yearsIncomeReport,
  notifications,
  brokers,
  custodyInvestments,
  custodyAndPosition,
  accountsFinancialPosition
})
